// extracted by mini-css-extract-plugin
export var section = "styles-module--section--f1c80";
export var slots = "styles-module--slots--86c0f";
export var title = "styles-module--title--7a825";
export var truncate = "styles-module--truncate--29175";